import InputField from "components/fields/InputField";
import logo from "../../assets/logo/main_logo.png";
import "./signin.css";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";

export default function SignIn() {
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    email: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

const initialValues = {
  email: "",
  password: "",
};


  const handleSubmit = async (values) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/login`,
        {
          email: values.email,
          password: values.password,
        }
      );
      console.log(res);
      if (res.data.isSuccess) {
        localStorage.setItem("hiedberg_admin_token", res.data.data.token);
        navigate("/admin/navbar");
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <div className="bg_image_container flex h-full min-h-[100vh] w-full items-center justify-center">
      <div className="w-full  max-w-[500px] rounded-2xl border border-white/30 bg-white p-5 shadow backdrop-blur-md sm:rounded-3xl sm:p-14">
        <img
          src={logo}
          alt="logo"
          className=" mx-auto mb-10 w-[150px] object-contain"
        />
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange }) => (
            <Form className="space-y-10">
              <TextField
                label="Email"
                name="email"
                variant="outlined"
                size="small"
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
                value={values.email}
                onChange={handleChange}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
              />
              <TextField
                label="Password"
                name="password"
                type="password"
                variant="outlined"
                size="small"
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
                value={values.password}
                onChange={handleChange}
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
              />

              <button
                type="submit"
                className="linear mt-2 w-full rounded-xl bg-[#45A2E8] py-[12px] text-base font-medium text-white transition duration-200 hover:bg-[#45a1e8e0] "
              >
                Sign In
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
